import React, {Component} from 'react'

class ReturnConfirm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      order: props.order,
      error: null,
    }
    this.widgetRef = React.createRef()
  }

  downloadLabel() {
    fetch(`https://${window.tbApiDomain}/get_return_label?shopify_return_id=${this.props.result}&shopify_order_id=${this.state.order.id.replace('gid://shopify/Order/', '')}`)
      .then((response) => response.text())
      .then((res) => {
        console.log(res)
        if(res.includes('https')) {
          window.open(res)
        } else {
          this.setState({
            error: res
          })
        }
      })
  }

  componentDidMount() {
    
  }

  render() {
    return (
      <div className='text-xs' ref={this.widgetRef}>
        <div className='mb-8'>
          <div className='mb-3.75'>
            Your return merchandise authorization (RMA) number is: <a className='underline'>{this.props.result}</a>
          </div>
          <div className='normal-case'>
            A confirmation email will be sent to <span className='underline'>{this.state.order.email}</span> with details of your return and RMA number.
          </div>
        </div>
        <div className='mb-5'>Next Steps</div>
        <div className='grid lg:grid-cols-3 gap-5'>
          <div className='border border-black p-5'>
            <div className='mb-5'>1. Your return documents</div>
            <div className='mb-[2.1875rem]'>All necessary documents to return your order are below. Please print them out and affix your label on the package and your invoice inside.</div>
            
            <button className='button hover:!bg-button hover:!text-white w-full !px-3.25 !py-2.5 !flex !items-center !justify-between !text-xs !h-8.5 mb-3.75'
              onClick={e => {this.downloadLabel()}}
            >
              Print Your Return Label
              <span className='w-3 h-3' dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-chevron-alt'] }} />
            </button>
            {
              this.state.error && <div className='text-tb-red text-xs text-left'>{this.state.error}</div>
            }
            {/* <button className='button hover:!bg-button hover:!text-white w-full !px-3.25 !py-2.5 !flex !items-center !justify-between !text-xs !h-8.5'>
              Print Your Return Invoice
              <span className='w-3 h-3' dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-chevron-alt'] }} />
            </button> */}
          </div>
          <div className='border border-black p-5 flex flex-col'>
            <div className='mb-5'>2. Attach documents to outside of package</div>
            <div className='grow flex items-center justify-center text-third-grey' dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-shipping-box'] }} />
          </div>
          <div className='border border-black p-5 flex flex-col'>
            <div className='mb-5'>3. Drop off package at the nearest UPS facility</div>
            <div className='grow flex items-center justify-center text-third-grey' dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-truck'] }} />
          </div>
        </div>
      </div>
    )
  }
}

export default ReturnConfirm